import type { WrappedReducer } from '../../../types/ReduxAsyncActions.types';
import type { CostFileTemplateCreatorState } from '../types';
import { COST_FILE_TEMPLATE_CREATOR_STEPS } from './costFileTemplateCreatorSteps';

export const INIT_STATE: WrappedReducer<CostFileTemplateCreatorState> = {
  loadingStatus: 0,
  loading: false,
  error: undefined,
  step: COST_FILE_TEMPLATE_CREATOR_STEPS.START,
  startStepVisited: true,
  mapStepVisited: false,
  validateStepVisited: false,
  id: undefined,
  title: '',
  adPartner: undefined,
  sampleFile: {
    uploadedFile: undefined,
    parsedCSV: undefined,
  },
  mapping: [],
};
